import $ from 'jquery'

const $dummy = $('<div class="dummy" />')
$(document.documentElement).append($dummy)

export const scrollbarCompensation = () => {
  const { offsetWidth, clientWidth } = $dummy[0]
  return offsetWidth - clientWidth
}